import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showLevel: false,
};

const levelSlice = createSlice({
  name: "level",
  initialState,
  reducers: {
    setShowLevel(state, action) {
      state.showLevel = action.payload;
    },
  },
});

export const { setShowLevel } = levelSlice.actions;

export default levelSlice.reducer;
